import * as React from 'react';
import { QueryResult } from 'apollo-client-ppc';

export const initialBillingState = { isMonthly: true };

export const initialFilterState = {
  products: false,
  apps: false,
};

export const initialIsTableLoading = false;
export const initialQuerySearch = undefined;
export const initialSearchResults = undefined;
export const existingCloudSiteProductIds = [];
export const sandboxCloudSiteParentProductIds = [];

export type FrequencyType = {
  isMonthly: boolean;
};

type PartnerProductCatalogueContextType = Partial<QueryResult> & {
  billingFrequencyState: FrequencyType;
  existingCloudSiteProductIds?: string[];
  sandboxCloudSiteParentProductIds?: string[];
  setCurrentBillingState: (state: FrequencyType) => void;
  filterState: any;
  setFilter: (filterValue: any) => void;
  searchResults: any;
  setSearchResults: (searchResults: any) => void;
  isTableLoading: boolean;
  setIsTableLoading: (isLoading: boolean) => void;
  querySearch: any;
  setQuerySearch: (querySearch: any) => void;
};

const PartnerProductCatalogueContext = React.createContext<PartnerProductCatalogueContextType>({
  billingFrequencyState: initialBillingState,
  existingCloudSiteProductIds: existingCloudSiteProductIds,
  sandboxCloudSiteParentProductIds: sandboxCloudSiteParentProductIds,
  setCurrentBillingState: () => {
    return;
  },
  setFilter: () => {
    return;
  },
  filterState: initialFilterState,
  searchResults: initialSearchResults,
  setSearchResults: () => {
    // Do nothing
  },
  isTableLoading: initialIsTableLoading,
  setIsTableLoading: () => {
    // Do nothing
  },
  querySearch: initialQuerySearch,
  setQuerySearch: () => {
    // Do nothing
  },
});

export default PartnerProductCatalogueContext;

export const usePartnerProductCatalogueContext = () => {
  const context = React.useContext(PartnerProductCatalogueContext);

  if (!context) {
    throw new Error('PartnerProductCatalogueContext has not been setup');
  }

  return context;
};
